import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m1.751 3.75 3 4.166v7.168c0 3.027 1.884 5.166 4.915 5.166h12.585"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.994 4.75h-5.74c-2 0-3.255 1.416-3.255 3.42v5.41c0 2.004 1.247 3.42 3.255 3.42h5.74c2.006 0 3.255-1.416 3.255-3.42V8.17c0-2.004-1.249-3.42-3.255-3.42",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M12.698 8.68h4.851"
    }, null, -1)
  ]))]))
}
export default { render: render }